import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useModal } from '../../context/ModalContext';
import ConfirmModal from './ConfirmModal';

/**
 * Componente que renderiza todos los modales globales
 * Se debe colocar en el Layout para que se renderice una sola vez
 */
function GlobalModals() {
    const { confirmState, hideConfirm, infoState, hideInfo } = useModal();

    const handleConfirm = () => {
        if (confirmState.onConfirm) {
            confirmState.onConfirm();
        }
        hideConfirm();
    };

    return (
        <>
            {/* Modal de Confirmación */}
            <ConfirmModal
                show={confirmState.show}
                onHide={hideConfirm}
                title={confirmState.title}
                message={confirmState.message}
                confirmLabel={confirmState.confirmLabel}
                cancelLabel={confirmState.cancelLabel}
                confirmVariant={confirmState.confirmVariant}
                onConfirm={handleConfirm}
            />

            {/* Modal Informativo */}
            <Modal show={infoState.show} onHide={hideInfo} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{infoState.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {infoState.message}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={hideInfo}>
                        {infoState.closeLabel}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default GlobalModals;
